import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export const TableCard = ({ className, children }) => {
  return (
    <Card className={cn("border-none shadow-md", className)}>
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  );
};
